import React, { useEffect, useState } from 'react'
import { DatePicker, DateTuple } from '../../DatePicker/DatePicker'
import { DatePickerButton } from '../../DatePicker/DatePickerButton'
import { WithCommonType } from '../types'

export type DatePickerTemplate = {
  value: DateTuple
}

export type DatePickerProps = WithCommonType<DatePickerTemplate>

const DatePickerTemplate = (props: DatePickerProps) => {
  const { value, onChange, name, index } = props
  const [date, setDate] = useState<DateTuple>(value)
  const [toDatePickerIsOpen, setToDatePickerIsOpen] = useState<boolean>(false)

  useEffect(() => {
    setDate(value)
  }, [value])

  const onDateChange = (newDate: DateTuple) => {
    onChange({ name, index, value: newDate })
    setDate(newDate)
  }

  return (
    <DatePicker
      value={date}
      isOpen={toDatePickerIsOpen}
      onClose={() => setToDatePickerIsOpen(false)}
      onChange={onDateChange}
      data-testid={`${name}-datePicker-test-id`}
    >
      <DatePickerButton
        id="set-date-at-to"
        value={date}
        onClear={() => {
          onDateChange([null, null])
        }}
        onClick={() => setToDatePickerIsOpen(prev => !prev)}
      />
    </DatePicker>
  )
}

export default DatePickerTemplate
